export const ONBOARDING_PROJECT_KEY = 'fluxrun.onboarding_project_v1';
export const SETUP_CHECKLIST_DISMISSED_KEY = 'fluxrun.setup_checklist_dismissed_v1';
